

import { Routes ,Route, Navigate } from 'react-router-dom';
import { usePageTracking } from "./tracking";

import 'semantic-ui-css/semantic.min.css'
import './darkTheme.css'

// System
import ListSystems from "./System/ListSystems"

// Call
import Calls from "./Call/Calls"

import AboutComponent from "./About/AboutComponent"

// Event
import ListEvents from "./Event/ListEvents"
import ViewEvent from "./Event/ViewEvent"
import ActivityChart from './Call/BetterActivityChart';

// Notifications
import NotificationsPage from "./Notifications/NotificationsPage"

// Auth
import LoginGate from "./Auth/LoginGate"

import DemoCalls from "./Demo/DemoCalls"


const App = () => {
usePageTracking();

return (
        <LoginGate>
          <Routes>
            <Route exact path="/" element={<Navigate to="/system/nswpsn" replace/>} />
            <Route exact path="/systems" element={<ListSystems/>} />
            <Route exact path="/system/:shortName" element={<Calls/>} />
            <Route exact path="/demo" element={<Navigate to="/demo/nswpsn" replace/>} />
            <Route exact path="/demo/:shortName" element={<DemoCalls/>} />
            <Route exact path="/events" element={<ListEvents/>} />
            <Route exact path="/events/:id" element={<ViewEvent/>} />
            <Route exact path="/notifications" element={<NotificationsPage/>} />
            <Route exact path="/about" element={<AboutComponent/>} />
            <Route exact path="/test" element={<ActivityChart/>} />
          </Routes>
        </LoginGate>
)
}

export default App;